import { useTranslation } from "react-i18next";

import { Header } from "@pentabd/ui";
import { IconLayersThree01 } from "@pentabd/icons";

import { ROUTES } from "@constants/routes";

const CreateRequisitionPageHeader = () => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconLayersThree01 fill="dark" size="20" />,
    },
    {
      label: t("SIDEBAR.INVENTORY.REQUISITION"),
      link: ROUTES.INVENTORY.REQUISITION,
    },
    {
      label: t("SIDEBAR.INVENTORY.ADD_NEW_REQUISITION"),
    },
  ];

  const headerText = {
    header: t("INVENTORY_REQUISITION.REQUISITION_CREATE.HEADING"),
    subHeader: t("INVENTORY_REQUISITION.REQUISITION_CREATE.DESCRIPTION"),
  };

  return (
    <Header
      headerText={headerText}
      breadcrumbs={breadcrumbs}
      // actions={[
      //   <Button fill="outline" type="light" size="xs">
      //     Cancel
      //   </Button>,
      //   <Button fill="fill" type="primary" size="xs">
      //     Save
      //   </Button>,
      // ]}
    />
  );
};

export default CreateRequisitionPageHeader;
